import { React, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import Lottie from 'lottie-react-web';

// Model //
import FetchModule from '../../../Model/Network/FetchModule';
// Model //

// Animation //
import LoadingAnimation from '../../../Animation/LoadingAnimation.json';
import RefundReasonInput from '../Component/RefundReasonInput';
// Animation //


export default function RefundModal(props) {
  const { data, refresh, onClickExit } = props;

  const [reason, setReason] = useState('');
  const [totalPrice, setTotalPrice] = useState(0);

  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState('환불 진행중');

  const navigate = useNavigate();

  // 스크롤 정지 //
  useEffect(() => {
    document.body.style = `overflow: hidden`;
    return () => document.body.style = `overflow: auto`;
  }, [])

  // 이전 환불 신청이 있는지 확인 및 세팅 //
  useEffect(() => {
    setTotalPrice(data.totalPrice);
  }, [data])

  // 로딩 텍스트 변경 //
  useEffect(() => {
    if (!isLoading) return;

    setTimeout(() => {
      if (loadingText === '환불 진행중') setLoadingText('환불 진행중.');
      else if (loadingText === '환불 진행중.') setLoadingText('환불 진행중..');
      else if (loadingText === '환불 진행중..') setLoadingText('환불 진행중...');
      else if (loadingText === '환불 진행중...') setLoadingText('환불 진행중');
    }, 800);
  }, [isLoading, loadingText])


  // 환불버튼 클릭시 //
  function onClickRefund() {
    if (isLoading) return;

    let requestData = {
      merchantUid: data.merchantUid,
      reason: reason,
    }

    setIsLoading(true);

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataOfEventVer2('sales/refund/admin', 'POST', requestData);

        if (responseData.status === 200) {
          setIsLoading(false);
          alert('환불을 완료했습니다');
          refresh();
          onClickExit();
        }
        else {
          alert(responseData.error);
          setIsLoading(false);
          return;
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      {
        isLoading ?
          <ViewWrapper>
            <LottieWrapper>
              <Lottie options={{ animationData: LoadingAnimation }} />
            </LottieWrapper>
            <LoadingTextWrapper>
              <Text fontFmaily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>{loadingText}</Text>
            </LoadingTextWrapper>
          </ViewWrapper>
          :
          <ModalTotalWrapper>
            <ModalView>
              <TitleWrapper>
                <Text fontFamily='NotoSansKR-Bold' fontSize={16} color='#FFFFFF' cursor='default'>신청권 환불하기</Text>
              </TitleWrapper>
              <ExplanationWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>선택한 결제내역에 대한 환불을 진행하며</Text>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>되돌릴 수 없습니다. 환불을 계속 하시겠습니까?</Text>
              </ExplanationWrapper>
              <ReasonBoxWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>사유</Text>
                <RefundReasonInput value={reason} setValue={setReason} placeholder='환불 사유를 적어주세요'/>
              </ReasonBoxWrapper>
              <RefundNoticeWrapper>
                <RefundNoticeTextWrapper>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>총</Text>
                  <Text style={{ marginLeft: '4px' }} fontFamily='NotoSansKR-Bold' fontSize={12} color='#FF0000' cursor='default'>{totalPrice.toLocaleString() + (data.isGlobalPayment ? 'USD' : '원')}</Text>
                  <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>을 환급합니다</Text>
                </RefundNoticeTextWrapper>
                <Text fontFamily='NotoSansKR-Regular' fontSize={12} color='#FFFFFF' cursor='default'>영업일 기준 5일 이내 카드취소 예정입니다</Text>
              </RefundNoticeWrapper>
              <ButtonWrapper>
                <ExitButton onClick={onClickExit}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>취소</Text>
                </ExitButton>
                <DeleteButton onClick={onClickRefund}>
                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#FFFFFF' cursor='pointer'>환불하기</Text>
                </DeleteButton>
              </ButtonWrapper>
            </ModalView>
          </ModalTotalWrapper>
      }
    </TopLevelWrapper>
  )
}

const startAnimation = keyframes`
	0% { opacity: 0; }
	50% { opacity: 0.5; }
	100% { opacity: 1; }
`;

const TopLevelWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 1000;
  
  width: 100vw;
  height: 100vh;

  overflow-y: scroll;

  background-color: rgba(0, 0, 0, 0.2);
  
	animation-name: ${startAnimation};
	animation-duration: 0.5s;
	animation-timing-function: ease-out;
`;

const ModalTotalWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;
`;

const ModalView = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  padding: 20px 15px 10px 15px;

  width: 436px;

  border-radius: 10px;
  box-shadow: 0px 40px 50px rgba(0, 0, 0, 0.1);
  background-color: #2F2F32;

  overflow: hidden;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
`;

const ExplanationWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 20px;

  width: 100%;

  gap: 4px;
`;

const ReasonBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  width: 100%;

  gap: 8px;
`;

const RefundNoticeWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: 10px;

  width: 100%;

  gap: 10px;
`;

const RefundNoticeTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  margin-top: 30px;

  width: 100%;

  gap: 10px;
`;

const ExitButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 62px;
  height: 40px;

  border-radius: 10px;
  background-color: #17171B;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const DeleteButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100px;
  height: 40px;

  border-radius: 10px;
  background-color: #FF0000;

  transition: all 0.3s ease-in-out;

  :hover {
    cursor: pointer;
  }
`;

const ViewWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 40px;

  width: 180px;
  height: 240px;

  overflow: hidden;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 160px;
  height: 160px;
`;

const LoadingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 140px;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  :hover {
    cursor: ${props => props.cursor};
  }
`;